'use strict';

var React = require('react');

module.exports = React.createClass({
	displayName: 'NewsTopStory',

	render: function () {

		var model = this.props.model;

		if (!(model && model.targetUrl)) {
			return false;
		}

		var prefixLabel = "SVT Nyheter";
		var prefixThemeClass = "svtse_news-top-story__news-prefix--theme-news";

		if(model.targetUrl.indexOf("/sport/") > -1){
			prefixLabel = "SVT Sport";
			prefixThemeClass = "svtse_news-top-story__news-prefix--theme-sport";
		}

		var prefixClasses = "svtse_news-top-story__news-prefix " + prefixThemeClass;

		return (
			<section className="svtse_section svtse_section--top-story">
				<article className="svtse_news-top-story">
					<h1 className="svtse_a11y-hidden">Toppnyheter från SVT Nyheter</h1>
					<a className="svtse_news-top-story__link" href={model.targetUrl}>
						<h2 className="svtse_news-top-story__headline">
							<span className={prefixClasses} aria-hidden="true">{prefixLabel}</span>
							<span className="svtse_news-top-story__headline-text">{model.title}</span>
						</h2>
					</a>
				</article>
			</section>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/news/NewsTopStory.jsx
 **/